import React from "react";
import { Container, Grid, Box } from "@mui/material";
import InfoSection from "../../widgets/checkout/info_section";
import CouponsSection from "../../widgets/checkout/coupons_section";
import PaymentSection from "../../widgets/checkout/payment_section";
import SummarySection from "../../widgets/checkout/summary_section";

export default function Checkout(props) {
  const { component } = props;

  const { order = null } = component.getData("default", {});

  return (
    <Box sx={{ backgroundColor: "#fafafa", minHeight: "50vh" }}>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          px: { xs: 1.5, sm: 2, md: 3 },
          py: { xs: 2.5, md: 4 },
        }}
        maxWidth="xl"
        disableGutters
      >
        {order && (
          <Grid
            container
            sx={{
              flexGrow: 1,
              justifyContent: "center",
              alignItems: "flex-start",
            }}
            direction="row"
            spacing={{ xs: 2, md: 3 }}
          >
            <Grid item md={7} xs={12}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <InfoSection {...props} />
                <CouponsSection {...props} />
                <PaymentSection {...props} />
              </Box>
            </Grid>
            <Grid item md={5} xs={12}>
              <Box
                sx={{
                  position: { md: "sticky" },
                  top: { md: 24 },
                }}
              >
                <SummarySection {...props} />
              </Box>
            </Grid>
          </Grid>
        )}
      </Container>
    </Box>
  );
}
